import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconButton } from '@eb/eds-icon-button';
import { CrossChunky } from '@eb/eds-iconography';

import './Notification.scss';

const Notification = (props) => {
    const [isMounted, setMounted] = useState(false);
    const { animateEntryDirection = 'left' } = props;

    const classes = classNames('notification', props.containerClasses, {
        [`notification__animate-entry--${animateEntryDirection}`]: !!props.shouldAnimateEntry,
        'notification__animate-entry': !!props.shouldAnimateEntry,
        'notification__animate-entry--mounted':
            !!props.shouldAnimateEntry && isMounted,
    });

    useEffect(() => {
        if (props.shouldAnimateEntry) {
            setMounted(true);
        }
    }, [props.shouldAnimateEntry]);

    return (
        <div className={classes} style={{ ...props.containerStyles }}>
            {!props.isNotDismissable && (
                <div className="notification__close">
                    <IconButton
                        iconType={<CrossChunky />}
                        onClick={props.onClose}
                        iconColor="ui-500"
                        title="Close Event Notification"
                    />
                </div>
            )}
            <section className="notification__content">
                {props.children}
            </section>
        </div>
    );
};

Notification.propTypes = {
    children: PropTypes.node.isRequired,
    containerClasses: PropTypes.string,
    containerStyles: PropTypes.object,
    shouldAnimate: PropTypes.bool,
};

export default Notification;
